import React from 'react';
import { useDropzone } from 'react-dropzone';


// DropZone component for handling file uploads via drag-and-drop
// It accepts files, displays a message or list of files, and allows customization of accepted file types and multiple file uploads
const DropZone = ({ onDrop, accept, file, text, isMultiple = false }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    multiple: isMultiple,
  });

  return (
    <div>
      <div {...getRootProps()} style={styles.dropzone}>
        <input {...getInputProps()} />
        {file && file.length > 0 ? (
          <ul>
            {file.map((f, idx) => (
              <li key={idx}>{f.name}</li>
            ))}
          </ul>
        ) : (
          <p>{text}</p>
        )}
      </div>
    </div>
  );
};

const styles = {
  dropzone: {
    border: '2px dashed #ccc',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '8px',
    minHeight: '100px',
    marginBottom: '10px',
  },
};

export default DropZone;
